import React, { Component } from 'react';
import { Container, Row, Col, Button, Alert, Card } from 'react-bootstrap';
import { connect } from "react-redux";
import API from './API';
// import { linkStrava } from "../actions/strava"; // Placeholder for action

class StravaLink extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            success: null,
            isConnected: false,
            loading: true
        };
    }

    componentDidMount() {
        this.checkConnectionStatus();

        const query = new URLSearchParams(this.props.location.search);
        const code = query.get('code');
        const error = query.get('error');

        if (code) {
            this.handleStravaCallback(code);
        } else if (error) {
            this.setState({ error: "Strava authentication failed: " + error });
        }
    }

    checkConnectionStatus = () => {
        API.getStravaConfig({
            token: this.props.auth.token,
            onSuccess: (res) => {
                this.setState({
                    isConnected: res.data.is_connected,
                    loading: false
                });
            },
            onError: (err) => {
                console.error("Failed to check status", err);
                this.setState({ loading: false });
            }
        });
    }

    handleStravaCallback = (code) => {
        API.linkStrava({
            token: this.props.auth.token,
            code: code,
            onSuccess: (res) => {
                console.log("Strava linked successfully", res);
                this.setState({ success: "Strava account linked successfully!", isConnected: true });
                // Clean URL
                window.history.replaceState({}, document.title, "/strava_link");
            },
            onError: (err) => {
                console.error("Strava link error", err);
                const msg = (err.data && err.data.error) ? err.data.error : "Unknown error";
                this.setState({ error: "Failed to link Strava account: " + msg });
            }
        });
    }

    handleConnect = () => {
        API.getStravaConfig({
            token: this.props.auth.token,
            onSuccess: (res) => {
                const clientId = res.data.client_id;
                const redirectUri = window.location.origin + "/strava_link";
                const scope = "read,activity:read_all";
                const authUrl = `https://www.strava.com/oauth/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}`;
                window.location.href = authUrl;
            },
            onError: (err) => {
                console.error("Failed to get Strava config", err);
                this.setState({ error: "Failed to initiate Strava connection." });
            }
        });
    }

    render() {
        const { isConnected, loading, error, success } = this.state;

        return (
            <Container className="mt-5">
                <Row className="justify-content-md-center">
                    <Col md={8}>
                        <Card>
                            <Card.Header as="h5">Strava連携</Card.Header>
                            <Card.Body>
                                <Card.Title>SmartSailingとStravaを連携します</Card.Title>
                                <Card.Text>
                                    Stravaアカウントと連携することで、Stravaにアップロードされたアクティビティデータを自動的にSmartSailingに取り込むことができます。
                                </Card.Text>

                                {error && <Alert variant="danger">{error}</Alert>}
                                {success && <Alert variant="success">{success}</Alert>}

                                {loading ? (
                                    <div className="text-center">Loading...</div>
                                ) : isConnected ? (
                                    <div className="text-center">
                                        <Alert variant="info">
                                            <h4>連携済みです</h4>
                                            <p>あなたのStravaアカウントは正常に連携されています。</p>
                                        </Alert>
                                        <Button
                                            onClick={this.handleDisconnect}
                                            variant="secondary"
                                            className="mt-3"
                                        >
                                            Strava連携を解除する
                                        </Button>
                                    </div>
                                ) : (
                                    <div className="text-center">
                                        <Button
                                            onClick={this.handleConnect}
                                            style={{
                                                backgroundColor: "#fc4c02",
                                                borderColor: "#fc4c02",
                                                color: "white",
                                                fontWeight: "bold",
                                                padding: "10px 20px"
                                            }}
                                        >
                                            Connect with Strava
                                        </Button>
                                    </div>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }

    handleDisconnect = () => {
        if (!window.confirm("Stravaとの連携を解除しますか？")) return;

        API.unlinkStrava({
            token: this.props.auth.token,
            onSuccess: (res) => {
                this.setState({ isConnected: false, success: "連携を解除しました。" });
            },
            onError: (err) => {
                console.error("Failed to disconnect", err);
                this.setState({ error: "連携解除に失敗しました。" });
            }
        });
    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
    }
}

export default connect(mapStateToProps)(StravaLink);
